import { ReactNode } from 'react';
import { ToastOptions, toast, ToastItem } from 'react-toastify';

const activeToasts = new Map<string, string | number>();

type ToastStatus = 'added' | 'updated' | 'removed';

function getDedupeKey(
  message: ReactNode,
  options?: ToastOptions,
): string | null {
  if (typeof message === 'string') return message;
  if (options?.toastId != null) return String(options.toastId);
  return null;
}

export function notify(message: ReactNode, options?: ToastOptions) {
  const dedupeKey = getDedupeKey(message, options);
  if (dedupeKey && activeToasts.has(dedupeKey)) return;

  const id = toast(message, options);
  if (dedupeKey) activeToasts.set(dedupeKey, id);
  return id;
}

notify.info = (message: ReactNode, options?: ToastOptions) => {
  const dedupeKey = getDedupeKey(message, options);
  if (dedupeKey && activeToasts.has(dedupeKey)) return;

  const id = toast.info(message, options);
  if (dedupeKey) activeToasts.set(dedupeKey, id);
  return id;
};

notify.error = (message: ReactNode, options?: ToastOptions) => {
  const dedupeKey = getDedupeKey(message, options);
  if (dedupeKey && activeToasts.has(dedupeKey)) return;

  const id = toast.error(message, options);
  if (dedupeKey) activeToasts.set(dedupeKey, id);
  return id;
};

notify.warn = (message: ReactNode, options?: ToastOptions) => {
  const dedupeKey = getDedupeKey(message, options);
  if (dedupeKey && activeToasts.has(dedupeKey)) return;

  const id = toast.warn(message, options);
  if (dedupeKey) activeToasts.set(dedupeKey, id);
  return id;
};

notify.success = (message: ReactNode, options?: ToastOptions) => {
  const dedupeKey = getDedupeKey(message, options);
  if (dedupeKey && activeToasts.has(dedupeKey)) return;

  const id = toast.success(message, options);
  if (dedupeKey) activeToasts.set(dedupeKey, id);
  return id;
};

notify.loading = (message: ReactNode, options?: ToastOptions) => {
  const dedupeKey = getDedupeKey(message, options);
  if (dedupeKey && activeToasts.has(dedupeKey)) return;

  const id = toast.loading(message, options);
  if (dedupeKey) activeToasts.set(dedupeKey, id);
  return id;
};

notify.dismiss = (toastId: string | number) => {
  for (const [msg, id] of activeToasts.entries()) {
    if (id === toastId) {
      activeToasts.delete(msg);
      break;
    }
  }
  toast.dismiss(toastId);
};

toast.onChange(payload => {
  const { id, status } = payload as ToastItem & { status: ToastStatus };

  // Clean up when toast is removed from UI
  if (status === 'removed') {
    for (const [msg, toastId] of activeToasts.entries()) {
      if (toastId === id) {
        activeToasts.delete(msg);
        break;
      }
    }
  }
});
